module.exports = __webpack_public_path__ + "img/retangule_bottom_right.1596b303.svg";